import React from 'react'

import styles from "./DynamicBanner.module.scss"

const DynamicBanner = () => {
    return (
        <a
            className={styles.ticker__wrapper}
            href={"https://disk.yandex.ru/i/uB-pWSrLa60MzA"}
            target="_blank"
            rel="noopener noreferrer"
        >
            <div className={styles.ticker__text}>
                <span>Как продлить лицензию приложения PSYCards? Информация о продлении лицензии приложения PSYCards!</span>
            </div>
        </a>
    )
}

export default DynamicBanner